type NotEditableFieldProps = {
  CustomerSupportAgent: {
    [key: string]: string[]
  }
  Teacher: {
    [key: string]: string[]
  }
}
/**
 * Don't forget to update the README.md!
 **/
export const notEditableFields: NotEditableFieldProps = {
  CustomerSupportAgent: {
    locked: ['level'],
    progress: ['level'],
    unlocked: ['level'],
    review: ['userType', 'level'],
    inactive: ['level'],
    deactivated: ['level'],
    disabled: ['level'],
    deleted: ['level'],
    completed: [],
    'completed-review': ['userType', 'level'],
    reactivated: ['level'],
    incomplete: [],
    linked: ['level'],
    waiting: ['level'],
    invited: [],
    unknown: ['level'],
    teacher: ['level'],
  },
  Teacher: {
    locked: ['gender', 'countryCode', 'device', 'level'],
    progress: [
      'gender',
      'instructionDate',
      'startTime',
      'endTime',
      'locationId',
      'countryCode',
      'device',
      'level',
    ],
    unlocked: [
      'gender',
      'instructionDate',
      'startTime',
      'endTime',
      'locationId',
      'countryCode',
      'device',
      'level',
    ],
    review: [
      'gender',
      'instructionDate',
      'startTime',
      'endTime',
      'locationId',
      'userType',
      'countryCode',
      'device',
      'level',
    ],
    inactive: ['gender', 'level'],
    deactivated: ['all'],
    disabled: ['all'],
    deleted: ['all'],
    completed: [
      'gender',
      'instructionDate',
      'startTime',
      'endTime',
      'locationId',
      'countryCode',
      'device',
      'level',
    ],
    'completed-review': [
      'gender',
      'instructionDate',
      'startTime',
      'endTime',
      'locationId',
      'userType',
      'countryCode',
      'device',
      'level',
    ],
    reactivated: ['gender', 'level'],
    incomplete: [
      'gender',
      'instructionDate',
      'startTime',
      'endTime',
      'locationId',
      'userType',
      'countryCode',
      'device',
      'level',
    ],
    linked: ['gender', 'level'],
    waiting: ['gender', 'countryCode', 'device', 'level'],
    invited: [
      'gender',
      'instructionDate',
      'startTime',
      'endTime',
      'locationId',
      'countryCode',
      'device',
      'level',
    ],
    unknown: ['all'],
    teacher: ['all'],
  },
}
